<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("PurchasesList.ImportPurchaseErr.title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-data-table
          :headers="headers"
          :items="errorPurchases"
          multi-sort
          class="elevation-1 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:item.index="{ item }">
            <span>
              {{ item.index }}
            </span>
          </template>
          <template v-slot:item.error_msg="{ item }">
            <span class="red--text">
              {{ item.error_msg }}
            </span>
          </template>
          <template v-slot:item.stock_name="{ item }">
            <span>
              {{ item.stock_name }}
            </span>
            <br />
            <span
              class="red--text"
              v-if="item.stock_error && item.stock_error != ''"
            >
              {{ item.stock_error }}
            </span>
          </template>
          <template v-slot:item.supplier_code="{ item }">
            <span> {{ item.supplier_code }} / {{ item.supplier_name }} </span>
            <br />
            <span
              class="red--text"
              v-if="item.supplier_error && item.supplier_error != ''"
            >
              {{ item.supplier_error }}
            </span>
          </template>
          <template v-slot:item.material_code="{ item }">
            <span> {{ item.material_code }} / {{ item.material_name }} </span>
            <br />
            <span
              class="red--text"
              v-if="item.material_error && item.material_error != ''"
            >
              {{ item.material_error }}
            </span>
          </template>
          <template v-slot:item.hope_delivery_date="{ item }">
            <span>
              {{ item.hope_delivery_date | formatDate }}
            </span>
            <br />
            <span
              class="red--text"
              v-if="item.data_error && item.data_error != ''"
            >
              {{ item.data_error }}
            </span>
          </template>
          <template v-slot:item.unit="{ item }">
            <span>
              {{ item.unit }}
            </span>
            <br />
            <span
              class="red--text"
              v-if="item.unit_error && item.unit_error != ''"
            >
              {{ item.unit_error }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";

export default {
  name: "ImportPurchasesResult",

  props: {
    value: Boolean,
    errorPurchases: Array,
  },
  computed: {
    headers: () => [
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.no"),
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.stock_name"),
        align: "start",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.ext_code"),
        align: "start",
        sortable: false,
        value: "ext_code",
      },
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.supplier"),
        align: "start",
        sortable: false,
        value: "supplier_code",
      },
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.material"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.unit"),
        align: "center",
        value: "unit",
        sortable: false,
        width: "100px",
      },
      {
        text: i18n.t("PurchasesList.ImportPurchaseErr.hope_delivery_date"),
        align: "start",
        sortable: false,
        value: "hope_delivery_date",
      },
    ],
    ...mapState(["loading"]),
  },
  data: () => ({
    dialog: false,
  }),
  methods: {},

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>